// extracted by mini-css-extract-plugin
module.exports = {"container":"NetworkStartsStreamsContainer_container__1fScU","description":"NetworkStartsStreamsContainer_description__21onX"};